import { render, staticRenderFns } from "./SurveyDashboard.vue?vue&type=template&id=21c83e4a&scoped=true&"
import script from "./SurveyDashboard.vue?vue&type=script&lang=js&"
export * from "./SurveyDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SurveyDashboard.vue?vue&type=style&index=0&id=21c83e4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c83e4a",
  null
  
)

export default component.exports